// Dev config
// export const ENV_CONFIG = {
//    CLIENT_ID: 'bccdc48a-8943-4326-86f0-b62b1403155d',
//    AUTHORITY: 'https://login.microsoftonline.com/ey.com/',
//    REDIRECT_URI: "https://localhost:3000",
//    CACHE_LOCATION: 'sessionStorage',
//    DOMAIN : 'ey.com',
//    API_SCOPE:'api://e4b17bed-b45f-47bf-88a1-71bb5d1eb45b/user_impersonation',
//    API_URI:'https://usedgpowap04.azurewebsites.net/api/',
//    AUTHORIZATION_ACCESS_REQUEST_DATA_AGENT_PORTAL:"mailto:rajagopal.pallath@gds.ey.com?cc=bibitha.bahuleyan@gds.ey.com;prasanth.christurajan@gds.ey.com&subject=Request for Access to GPO Agent Portal&body=Dear Admin,%0AKindly provide access to the application."
//    //mail to can be configured as follows:
//    //"mailto:xyz@mail.com;abc@mail.com?cc=abc1@mail.com;abc2@mail.com&bcc=abc1@mail.com&subject=Subject here&body=Body-goes-here"
// };

//Prod config
 export const ENV_CONFIG = {
     CLIENT_ID: 'e2c9cd6d-fa9c-4745-8585-0433996b3705',
     AUTHORITY: 'https://login.microsoftonline.com/ey.com/',
     REDIRECT_URI: 'https://talent-ai-admin-dev.ey.com/',
     CACHE_LOCATION: 'sessionStorage',
     DOMAIN: 'ey.com',
     API_SCOPE: 'api://e2c9cd6d-fa9c-4745-8585-0433996b3705/user_impersonation',
     API_URI: 'https://api1-talent-ai-dev.ey.com/api/',
     AUTHORIZATION_ACCESS_REQUEST_DATA_AGENT_PORTAL:'mailto:philip.shu@ey.com;sergii.trotskyi@gds.ey.com?subject=Request for Access to Talent AI Admin Portal&body=Dear Admin,%0A%09Kindly provide access to the Talent AI Admin Portal application.'
 };
